import React from "react";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { GlobalContext } from "../../context/GlobalContext";
import { icon } from "@fortawesome/fontawesome-svg-core";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";

const markerIcon = L.divIcon({
  className: "fontawesome-marker",
  html: icon(faLocationDot).html.join(""),
  iconSize: [40, 40],
  iconAnchor: [20, 40],
});

function MapUpdater({ position, locations }) {
  const map = useMap();

  React.useEffect(() => {
    map.setView(position, locations?.length > 1 ? 6 : 15);
  }, [map, position]);

  return null;
}

export default function OpenMap({ locations }) {
  const { isMobile } = React.useContext(GlobalContext);
  const firstPosition =
    locations?.length > 1
      ? [49.432184553552, 10.970255626380085]
      : [locations?.[0].latitude, locations?.[0].longitude];
  const mapHeight = isMobile ? "300px" : "500px";

  return (
    <MapContainer
      center={firstPosition}
      zoom={locations?.length > 1 ? 6 : 15}
      style={{ height: mapHeight, width: "100%" }}
      className="my-openmap-container"
    >
      <MapUpdater position={firstPosition} locations={locations} />
      <TileLayer
        attribution="&copy; OpenStreetMap contributors"
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        className="openmap-tilelayer-gray-map"
      />

      {locations?.map((location) => (
        <Marker
          key={`${location.latitude}-${location.longitude}`}
          position={[location.latitude, location.longitude]}
          icon={markerIcon}
        >
          <Popup>{location.name}</Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
